import { render } from "./EventView.vue?vue&type=template&id=0b8cd96e&ts=true"
import script from "./EventView.vue?vue&type=script&lang=ts"
export * from "./EventView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__